import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react/macro";

import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";

import CalendarIcon from "@/assets/icons/calendar.svg?react";
import ContentIcon from "@/assets/icons/content.svg?react";
import CreditCardIcon from "@/assets/icons/credit-card.svg?react";
import EllpseIcon from "@/assets/icons/ellipse.svg?react";
import FacilityIcon from "@/assets/icons/facility.svg?react";
import HomeIcon from "@/assets/icons/home.svg?react";
import InfoIcon from "@/assets/icons/info.svg?react";
import InsuranceIcon from "@/assets/icons/insurance.svg?react";
import LocationIcon from "@/assets/icons/location.svg?react";
import SaleIcon from "@/assets/icons/sale.svg?react";
import ShieldIcon from "@/assets/icons/shield.svg?react";

const guestsNavItems = [
  { title: msg`General Information`, Icon: InfoIcon, value: "general" },
  { title: msg`Reservations & Cancellations`, Icon: CalendarIcon, value: "reservations" },
  { title: msg`Residences`, Icon: HomeIcon, value: "residences" },
  { title: msg`Facilities & Amenities`, Icon: FacilityIcon, value: "facilities" },
  { title: msg`Location`, Icon: LocationIcon, value: "location" },
  { title: msg`Promotions And Offers`, Icon: SaleIcon, value: "promotions" },
];

const OwnersNavItems = [
  { title: msg`General Information`, Icon: InfoIcon, value: "general" },
  { title: msg`Safety & Insurance`, Icon: ShieldIcon, value: "safety" },
  { title: msg`Management`, Icon: ContentIcon, value: "management" },
  { title: msg`Pricing & Payments`, Icon: CreditCardIcon, value: "pricing" },
  { title: msg`Policies`, Icon: InsuranceIcon, value: "policies" },
];

const FilterNavigation = ({
  type,
  selectedCategory,
  setSelectedCategory,
}: {
  type: string;
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
}) => {
  const navItems = type === "owners" ? OwnersNavItems : guestsNavItems;
  const { i18n } = useLingui();

  return (
    <div className="nav-slider flex gap-2 overflow-x-auto md:flex-col md:gap-4">
      {navItems.map((item) => (
        <Button
          key={item.value}
          onClick={() => setSelectedCategory(item.value)}
          variant="ghost"
          className={cn(
            "relative flex h-11 items-center justify-between px-2.5 md:pe-12",
            item.value === selectedCategory && "bg-(--color-bg-color-bg-dark-beige)",
          )}
        >
          <span className="flex items-center gap-2 text-sm font-semibold md:text-base">
            {item.Icon && (
              <item.Icon
                className={cn(
                  "size-6 group-data-[status=active]/link:fill-(--color-text-color-text-grey)",
                )}
              />
            )}
            {i18n._(item.title)}
          </span>
          {item.value === selectedCategory && (
            <EllpseIcon className="absolute end-0 end-4 hidden md:block" />
          )}
        </Button>
      ))}
    </div>
  );
};

export default FilterNavigation;
